module.exports = __webpack_public_path__ + "static/media/sub_boost.4e46328b.png";